import _ from 'lodash';
import capitalize from 'lodash/capitalize';

import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Autocomplete from '@mui/material/Autocomplete';

// ----------------------------------------------------------------------

type Option = { code: string; label: string };

type Props = {
  filterCode: string;
  filterName: string;
  options: Option[];
  [key: string]: unknown;
};

export default function MultiselectWithSearch({ filterCode: _filterCode, filterName, options, ...others }: Props) {
  return (
    <Stack>
      <Typography variant="subtitle2" sx={{ mb: 1.5 }}>
        {filterName}
      </Typography>

      <Autocomplete
        multiple
        disableCloseOnSelect
        options={options}
        clearOnBlur={false}
        ListboxProps={{ style: { maxHeight: '10rem' } }}
        {...others}
        getOptionLabel={(option) => String((option as Option).label)}
        isOptionEqualToValue={(option, value) =>
          String((option as Option).code) === String((value as Option).code)
        }
        renderInput={(params) => <TextField placeholder={`Wybierz ${filterName}`} {...params} />}
        renderOption={(props, option) => (
          <li {...props} key={(option as Option).code}>
            {capitalize((option as Option).label)}
          </li>
        )}
        renderTags={(selected, getTagProps) =>
          (selected as Option[]).map((option, index) => (
            <Chip
              {...getTagProps({ index })}
              key={option.code}
              size="small"
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              variant={'soft' as any}
              label={option.label}
            />
          ))
        }
      />
    </Stack>
  );
}

